/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { XpMultiplier } from './XpMultiplier';
import {
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
    XpMultiplierToJSONTyped,
} from './XpMultiplier';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { CheatFlagHistoryEntry } from './CheatFlagHistoryEntry';
import {
    CheatFlagHistoryEntryFromJSON,
    CheatFlagHistoryEntryFromJSONTyped,
    CheatFlagHistoryEntryToJSON,
    CheatFlagHistoryEntryToJSONTyped,
} from './CheatFlagHistoryEntry';
import type { DiscordInfo } from './DiscordInfo';
import {
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    DiscordInfoToJSONTyped,
} from './DiscordInfo';
import type { GamerTag } from './GamerTag';
import {
    GamerTagFromJSON,
    GamerTagFromJSONTyped,
    GamerTagToJSON,
    GamerTagToJSONTyped,
} from './GamerTag';
import type { CookieConsent } from './CookieConsent';
import {
    CookieConsentFromJSON,
    CookieConsentFromJSONTyped,
    CookieConsentToJSON,
    CookieConsentToJSONTyped,
} from './CookieConsent';
import type { DateOfBirthHistoryEntry } from './DateOfBirthHistoryEntry';
import {
    DateOfBirthHistoryEntryFromJSON,
    DateOfBirthHistoryEntryFromJSONTyped,
    DateOfBirthHistoryEntryToJSON,
    DateOfBirthHistoryEntryToJSONTyped,
} from './DateOfBirthHistoryEntry';
import type { AddressBook } from './AddressBook';
import {
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    AddressBookToJSONTyped,
} from './AddressBook';
import type { UserOrigin } from './UserOrigin';
import {
    UserOriginFromJSON,
    UserOriginFromJSONTyped,
    UserOriginToJSON,
    UserOriginToJSONTyped,
} from './UserOrigin';
import type { SubscriptionTierStatus } from './SubscriptionTierStatus';
import {
    SubscriptionTierStatusFromJSON,
    SubscriptionTierStatusFromJSONTyped,
    SubscriptionTierStatusToJSON,
    SubscriptionTierStatusToJSONTyped,
} from './SubscriptionTierStatus';
import type { AccountStatusHistoryEntry } from './AccountStatusHistoryEntry';
import {
    AccountStatusHistoryEntryFromJSON,
    AccountStatusHistoryEntryFromJSONTyped,
    AccountStatusHistoryEntryToJSON,
    AccountStatusHistoryEntryToJSONTyped,
} from './AccountStatusHistoryEntry';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { ChallengeMembership } from './ChallengeMembership';
import {
    ChallengeMembershipFromJSON,
    ChallengeMembershipFromJSONTyped,
    ChallengeMembershipToJSON,
    ChallengeMembershipToJSONTyped,
} from './ChallengeMembership';
import type { QuestProgression } from './QuestProgression';
import {
    QuestProgressionFromJSON,
    QuestProgressionFromJSONTyped,
    QuestProgressionToJSON,
    QuestProgressionToJSONTyped,
} from './QuestProgression';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface ChallengeSummaryUser
 */
export interface ChallengeSummaryUser extends User {
    /**
     * 
     * @type {ChallengeMembership}
     * @memberof ChallengeSummaryUser
     */
    challengeMembership: ChallengeMembership;
    /**
     * 
     * @type {Array<QuestProgression>}
     * @memberof ChallengeSummaryUser
     */
    questProgressions: Array<QuestProgression>;
    /**
     * 
     * @type {number}
     * @memberof ChallengeSummaryUser
     */
    pointsTotal: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeSummaryUser
     */
    eventsTotal: number;
}



/**
 * Check if a given object implements the ChallengeSummaryUser interface.
 */
export function instanceOfChallengeSummaryUser(value: object): value is ChallengeSummaryUser {
    if (!('challengeMembership' in value) || value['challengeMembership'] === undefined) return false;
    if (!('questProgressions' in value) || value['questProgressions'] === undefined) return false;
    if (!('pointsTotal' in value) || value['pointsTotal'] === undefined) return false;
    if (!('eventsTotal' in value) || value['eventsTotal'] === undefined) return false;
    return true;
}

export function ChallengeSummaryUserFromJSON(json: any): ChallengeSummaryUser {
    return ChallengeSummaryUserFromJSONTyped(json, false);
}

export function ChallengeSummaryUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeSummaryUser {
    if (json == null) {
        return json;
    }
    return {
        ...UserFromJSONTyped(json, true),
        'challengeMembership': ChallengeMembershipFromJSON(json['challengeMembership']),
        'questProgressions': ((json['questProgressions'] as Array<any>).map(QuestProgressionFromJSON)),
        'pointsTotal': json['pointsTotal'],
        'eventsTotal': json['eventsTotal'],
    };
}

export function ChallengeSummaryUserToJSON(json: any): ChallengeSummaryUser {
    return ChallengeSummaryUserToJSONTyped(json, false);
}

export function ChallengeSummaryUserToJSONTyped(value?: ChallengeSummaryUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...UserToJSONTyped(value, true),
        'challengeMembership': ChallengeMembershipToJSON(value['challengeMembership']),
        'questProgressions': ((value['questProgressions'] as Array<any>).map(QuestProgressionToJSON)),
        'pointsTotal': value['pointsTotal'],
        'eventsTotal': value['eventsTotal'],
    };
}

